var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInvitationExpired = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(-663 -294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M25,45A20,20,0,0,1,10.858,10.857,20,20,0,0,1,39.143,39.142,19.873,19.873,0,0,1,25,45ZM25,7.051a17.947,17.947,0,1,0,12.691,5.257A17.836,17.836,0,0,0,25,7.051Z",
    transform: "translate(658 289)",
    fill: "#ff1414"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(669.463 303.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M3.631,11.392H8.365a1.928,1.928,0,0,0,1.923-1.837H7.98a.642.642,0,1,1,0-1.284h2.308A1.928,1.928,0,0,0,8.365,6.435H3.631A1.928,1.928,0,0,0,1.707,8.36V9.468a1.927,1.927,0,0,0,1.924,1.924ZM16,18.185a.437.437,0,1,1-.86.15l-.569-3.225a.437.437,0,1,1,.86-.15ZM8.836,16.041a.436.436,0,0,1-.56-.669l2.508-2.105a.436.436,0,0,1,.56.669Zm3.488,1.5a.436.436,0,0,1-.819-.3l1.12-3.077a.436.436,0,0,1,.819.3ZM18.61,3.195a.435.435,0,1,1,.669.556L17.186,6.269a.435.435,0,1,1-.669-.556Zm-7.433-.833a.436.436,0,0,1,.819-.3L13.13,5.133a.436.436,0,1,1-.819.3L11.176,2.362Zm3.733-.025a.436.436,0,0,1,.86.147l-.553,3.228a.436.436,0,0,1-.86-.147l.553-3.228Zm4.815,8.511a.64.64,0,1,1-.642,1.108l-2-1.154a1.937,1.937,0,0,0,.745,2.556l4.1,2.367a1.934,1.934,0,0,0,2.624-.695l.56-.971a1.935,1.935,0,0,0-.706-2.631l-4.1-2.367a1.938,1.938,0,0,0-2.587.631l2,1.156Zm-3.75-.687-1.2-.693a.64.64,0,1,1,.642-1.108l1.2.693a3.209,3.209,0,0,1,4.336-1.1l4.1,2.367A3.208,3.208,0,0,1,26.223,14.7l-.58,1.005a3.211,3.211,0,0,1-4.3,1.157l-.1-.059-4.046-2.336a3.21,3.21,0,0,1-1.217-4.3Zm-4.4-1.889h1.384a.642.642,0,0,1,0,1.284H11.571a3.2,3.2,0,0,1-.939,2.174l0,0a3.2,3.2,0,0,1-2.264.942H3.631a3.2,3.2,0,0,1-2.262-.94l0,0A3.2,3.2,0,0,1,.423,9.468V8.36A3.2,3.2,0,0,1,1.364,6.1l0,0a3.2,3.2,0,0,1,2.263-.942H8.365a3.2,3.2,0,0,1,2.262.94l0,0a3.2,3.2,0,0,1,.94,2.176Z",
    transform: "translate(0 0)",
    fill: "#ff1414"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInvitationExpired);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/invitation_expired.397c6eafa11c685ab3c44b500a3a408e.svg";